<template>
  <div
    class="flex flex-col items-start"
    :class="
      bordered
        ? 'w-full pt-6 px-6 pb-4 gap-2 border-b border-solid border-gray-100 dark:border-slate-700 shadow-[0px_1px_4px_0px_rgba(202,202,202,0.16)]'
        : 'pt-8 px-8 pb-0'
    "
  >
    <img v-if="headerImage" :src="headerImage" alt="No image" />
    <div class="flex items-center gap-2 w-full">
      <dashboard-icon
        v-if="headerIcon"
        :icon="headerIcon"
        size="24"
        class="text-slate-600 dark:text-slate-300 shrink-0"
      />
      <h2
        ref="modalHeaderTitle"
        class="text-slate-800 text-lg dark:text-slate-100"
        :class="{ 'font-semibold leading-5 !mb-0 flex-1': bordered }"
      >
        {{ headerTitle }}
      </h2>
    </div>
    <p
      v-if="headerWarn"
      ref="modalHeaderWarn"
      class="w-full break-words !text-red-600 mt-2 text-sm !dark:text-red-300"
    >
      {{ headerWarn }}
    </p>
    <p
      v-if="headerContent"
      ref="modalHeaderContent"
      class="w-full break-words text-slate-600 text-sm dark:text-slate-300"
      :class="bordered ? '!mt-0' : 'mt-2'"
    >
      <span style="white-space: pre-line">{{ headerContent }}</span>
      <span
        v-if="headerContentValue"
        class="font-semibold text-sm text-slate-600 dark:text-slate-300"
      >
        {{ headerContentValue }}
      </span>
    </p>
    <slot />
  </div>
</template>

<script>
import DashboardIcon from 'shared/components/FluentIcon/DashboardIcon.vue';

export default {
  components: {
    DashboardIcon,
  },
  props: {
    headerTitle: {
      type: String,
      default: '',
    },
    headerContent: {
      type: String,
      default: '',
    },
    headerContentValue: {
      type: String,
      default: '',
    },
    headerImage: {
      type: String,
      default: '',
    },
    headerWarn: {
      type: String,
      default: '',
    },
    headerIcon: {
      type: String,
      default: '',
    },
    // Opt-in to the bordered header used by the new conversation modals.
    bordered: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
